import React, { useEffect, useState, useRef } from 'react';
import { FormGroup, FormControl, FormControlLabel, FormHelperText, Grid, TextField, Typography, Checkbox, FormLabel, DatePicker, InputAdornment, Radio, RadioGroup, Box, Button, Link, SelectField, Option } from "@deere/fuel-react";
import { containsCheckBoxAnswer, findAnswerIndex, findSelectionIndex, formatStrDate, getTranslation } from "../utils/utils";
import { getValidator } from "../utils/validationRequiredFactory";
import { DEFAULT_GRID_COLLUMNS, QUESTION_TYPES } from "../utils/surveyLiterals";
import { showInputTextErorr } from "../utils/validation";
import { useTranslation } from "react-i18next";
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import moment from "moment";
import { ReactComponent as FileUploadIcon } from "@deere/ux.brand-foundations/icons/upload.svg";
import { OverlayTrigger, Popover } from '@deere/ux.uxframe-react';
import { getFileS3 } from '../services/survey.service';
import { useOktaAuth } from '@okta/okta-react';

function shouldRender(question, answers, review, questions) {
  let shouldRender = true;
  if (question.idQuestionDepends !== null && question.idSelectionDependson !== null) {
    shouldRender = false;
    let answerQuestion = answers ? answers.find((ans) => parseInt(ans.questionId) === parseInt(question.idQuestionDepends)) : null;
    if (question.regexp === "notdepends") {
      if (answerQuestion && answerQuestion.answer && !answerQuestion.answer.toString().includes(question.idSelectionDependson.toString())) {
        shouldRender = true;
      }
    } else {
      if (answerQuestion && answerQuestion.value && answerQuestion.value.toString() === question.idSelectionDependson.toString()) shouldRender = true;

      if (answerQuestion && answerQuestion.answer && answerQuestion.answer.toString() === question.idSelectionDependson.toString()) shouldRender = true;

      if (shouldRender === true) {
        // Validating grand parent question
        let parentQuestion = questions.find((ques) => parseInt(ques.id) === parseInt(question.idQuestionDepends));
        if (parentQuestion && parentQuestion.idQuestionDepends !== null && parentQuestion.idSelectionDependson !== null) {
          let answerQuestionParent = answers.find((ans) => parseInt(ans.questionId) === parseInt(parentQuestion.idQuestionDepends));
          if (!answerQuestionParent || answerQuestionParent.answer.toString() !== parentQuestion.idSelectionDependson.toString()) {
            shouldRender = false;
          }
        }
      }
    }
  }

  return shouldRender;
}

const QuestionsComponent = ({ survey, questions, answers, setIsSubmitted, pushAnswer, popAnswer, review, section, questionsToValidate, isSubmit, campaign,  setUploadedFiles, uploadedFiles, surveyCode, assignmentId, token, isAuthMethodOkta }) => {
  const { t } = useTranslation();
  const requiredValidator = getValidator(survey.code);
  const [fileFormatError, setFileFormatError] = useState(false);
  const fileInputref = useRef([]);
  const { authState } = useOktaAuth();

  useEffect(() => {
    if (uploadedFiles && uploadedFiles.length === 0 && answers && answers.length > 0) {
      const tempArr = [];
      answers.forEach((ans) => {
        const queIdx = questions.findIndex((que) => que.id === ans.questionId);
        if (queIdx > -1 && questions[queIdx].type === QUESTION_TYPES.FILE) {
          (ans.answer ?? '').split(", ").forEach((a) => {
            const match = a.match(/rn\d+(file\d+)\.pdf/);
            const fileNumber = match ? match[1] : null;
            if (fileNumber) tempArr.push({ fileName: a, fileNumber: fileNumber });
          });
        }
      });
      if (tempArr.length > 0)  setUploadedFiles(tempArr);
    }
  }, [uploadedFiles, answers]);

  const updateAnswer = (e, questionId, questionSelections) => {
    setIsSubmitted(false);
    pushAnswer(questionId, e.target ? e.target.value : e);
  };
  const updateCheckAnswer = (e, question) => {
    setIsSubmitted(false);
    let questionIndex = findAnswerIndex(question.id, answers);
    questionIndex >= 0 ? popAnswer(question.id) : pushAnswer(question.id, e.target ? e.target.value : null);
  };
  const datePickerOnChange = (e, question) => {
    const event = { target: { value: "" } };
    let dateValue = new Date();
    if (Array.isArray(e) && e.length > 0) {
      dateValue = moment(e[0]).isValid() ? e[0] : new Date();
      event.target.value = dateValue;
    } else {
      event.target.value = dateValue;
    }
    updateAnswer(event, question);
  };

  function createCheckSection(question) {
    let indx = findAnswerIndex(question.id, answers);
    let answer = indx >= 0 ? answers[indx].answer : "";
    let required = review ? false : requiredValidator(question, section, answers, questionsToValidate);
    let isError = typeof isSubmit === "boolean" && isSubmit ? showInputTextErorr(answers, question.id) : false;

    return (
      shouldRender(question, answers, review, questions) && (
        <>
          <Typography size="sm" component="p" gutterBottom fontWeight="semibold" key={`q${question.questionId}`}>
            {getTranslation(question, "text")}
          </Typography>
          {
            <div id={question.questionId}>
              <>
                {review
                  ? question.selections
                      .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
                      .map((i) =>
                        i.active && answer === i.value.toString() ? (
                          <div key={i.id}>
                            <Typography size="sm" component="p" gutterBottom key={i.id}>
                              {" "}
                              {i !== null ? getTranslation(i, "text") : ""}
                            </Typography>
                            <br />
                          </div>
                        ) : (
                          ""
                        )
                      )
                  : question.selections
                      .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
                      .map((i) =>
                        i.active ? (
                          <FormControl error={isError} key={i.id}>
                            <FormGroup required={required !== undefined && required !== null ? required : question.required} >
                              <FormControlLabel
                                control={<Checkbox name={`${getTranslation(section, "description")}-${question.id}`} />}
                                sx={{
                                  alignItems: "start",
                                  "& .MuiFormControlLabel-label": { fontSize: "12px!important" },
                                }}
                                value={i.value}
                                id={i.id}
                                label={getTranslation(i, "text")}
                                name={`${getTranslation(section, "description")}-${question.id}`}
                                onChange={(e) => updateCheckAnswer(e, question, i.exclusive)}
                                data-testid={i.id}
                                checked={containsCheckBoxAnswer(i.value, answer)}
                              />
                            </FormGroup>
                            {isError ? <FormHelperText> {t("bs_required")}</FormHelperText> : null}
                          </FormControl>
                        ) : (
                          ""
                        )
                      )}
              </>
            </div>
          }
        </>
      )
    );
  }

  function createRadioSection(question) {
          let indx = findAnswerIndex(question.id, answers);
          let answer = indx >= 0 ? answers[indx].answer : -1;
          let selectionIdx = answer !== "" && answer ? findSelectionIndex(answer, question.selections) : -1;
          let selection = selectionIdx >= 0 ? question.selections[selectionIdx] : null
          let required = review ? false : requiredValidator(question, section, answers, questionsToValidate);
          let isError = (typeof isSubmit === 'boolean' && isSubmit) ? showInputTextErorr(answers, question.id) : false; 
          let questionSelections = question.selections;
          
          return shouldRender(question, answers, review, questions) && <FormControl fullWidth>
                  {
                      review ?
                          <Box key={`b-${question.id}`}>
                              <Typography size="sm" component="p" gutterBottom key={`q${question.questionId}`} paddingLeft={question.idQuestionDepends ? '1.5rem':''} fontWeight="semibold" >
                                  {getTranslation(question, 'text')}
                              </Typography>
                              <Typography size="sm" component="p" gutterBottom key={`a${question.questionId}`} paddingLeft={question.idQuestionDepends ? '1.5rem':''}>
                                  {selection !== null ? getTranslation(selection, 'text') : ''}
                              </Typography>
                          </Box>
                          : <FormControl sx={{ m: 3 }}  variant="standard" error={isError} >
                              <FormLabel>
                                  <Typography size="sm" component="p" gutterBottom key={`${question.questionId}`} fontWeight="semibold">
                                      {getTranslation(question, 'text')}
                                  </Typography>
                              </FormLabel>
                              <RadioGroup name={`radioGroup-${question.id}`} id={`radioGroup-${question.id}`} row  required>
                                  {question.selections.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1).map((i) =>
                                      i.active ? <FormControlLabel
                                          sx={{
                                              paddingLeft: question.idQuestionDepends ? 4 : 0,
                                              alignItems: 'start',
                                              "& .MuiStack-root": {
                                                  display: "flex",
                                                  flexDirection: "row",
                                              }
                                          }}
                                          control={<Radio required={required !== undefined && required !== null ? required : question.required}/>}
                                          value={i.value}
                                          id={i.id}
                                          key={i.id}
                                          label={<FormHelperText><Typography paragraph sx={{ textAlign: 'justify', whiteSpace: 'pre-wrap' }}>{getTranslation(i, 'text')}</Typography></FormHelperText>}
                                          name={`${getTranslation(section, 'description')}-${question.id}`}
                                          onChange={(e) => updateAnswer(e, question.id, questionSelections)} data-testid={i.id}
                                          checked={indx >= 0 && answer && answer === i.value} />
                                          : ''
                                  )}
                              </RadioGroup>
                                  {
                                      isError ? <FormHelperText>{ t('bs_required')} </FormHelperText> : null
                                  }
                              </FormControl>
                  }
          </FormControl>
      }

  function createInput(question) {
    let required = review ? false : requiredValidator(question, section, answers, questionsToValidate);
    let indx = findAnswerIndex(question.id, answers);
    let isError = typeof isSubmit === "boolean" && isSubmit ? showInputTextErorr(answers, question.id) : false;
    return (
      shouldRender(question, answers, review, questions) && (
        <>
          {review ? (
            <>
              <Typography size="sm" component="p" gutterBottom key={`q${question.questionId}`} fontWeight="semibold">
                {getTranslation(question, "text")}
              </Typography>
              <Typography size="sm" component="p" gutterBottom key={`a${question.questionId}`}>
                {indx >= 0 ? answers[indx].answer : ""}
              </Typography>
            </>
          ) : (
            <>
              <TextField
                required={required !== undefined && required !== null ? required : question.required}
                onChange={(e) => updateAnswer(e, question.id)}
                value={indx >= 0 ? answers[indx].answer : ""}
                name={`${getTranslation(section, "description")}-${question.id}`}
                error={isError}
                variant="outlined"
                helperText={isError ? t("bs_required") : ""}
                label={getTranslation(question, "text")}
                sx={{ "& .MuiFormLabel-root": { fontSize: "12px" } }}
              />
            </>
          )}
        </>
      )
    );
  }

  const createDatePicker = (question) => {
    let required = review ? false : requiredValidator(question, section, answers, questionsToValidate);
    let indx = findAnswerIndex(question.id, answers);
    let isError = typeof isSubmit === "boolean" && isSubmit ? showInputTextErorr(answers, question.id) : false;
    return (
      shouldRender(question, answers, review, questions) && (
        <>
          {review ? (
            <>
              <Typography size="sm" component="p" gutterBottom key={`q${question.questionId}`} fontWeight="semibold">
                {getTranslation(question, "text")}
              </Typography>
              <Typography size="sm" component="p" gutterBottom key={`a${question.questionId}`}>
                {indx >= 0 ? formatStrDate(answers[indx].answer) : ""}
              </Typography>
            </>
          ) : (
            <FormControl
              sx={{ "& .MuiFormLabel-root": { fontSize: "14px" }, "& .MuiFormLabel-asterisk": { color: "#c21020" } }}
              fullWidth
              required={required !== undefined && required !== null ? required : question.required}
            >
              <FormLabel>{getTranslation(question, "text")}</FormLabel>
              <DatePicker
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CalendarMonth />
                    </InputAdornment>
                  ),
                  required: required !== undefined && required !== null ? required : question.required,
                  name: `${getTranslation(section, "description")}-${question.id}`,
                  error: isError,
                  helperText: isError ? t("bs_required") : "",
                }}
                onChange={(e) => datePickerOnChange(e, question.id)}
                name={`${getTranslation(section, "description")}-${question.id}`}
                value={indx >= 0 ? answers[indx].answer : ""}
              />
            </FormControl>
          )}
        </>
      )
    );
  };

  const updateAnswerFile = (e, questionId) => {
    setFileFormatError(false);
    setIsSubmitted(false);
    const requestNumber = campaign? campaign.assignments[0].id : ''; 
    const fileName = e.target.files[0]? e.target.files[0].name :'';
    const fileType = fileName.split(".")[fileName.split(".").length - 1];
    if (fileName.split(".").length === 1) {
      setFileFormatError(true);
      e.target.value = null;
    } else {
      let indx = findAnswerIndex(questionId, answers);
      const answer = indx >= 0 ? answers[indx].answer : "";
      // Find the highest file number used so far
      const maxFileNum = uploadedFiles.reduce((max, file) => {
        const match = file.fileNumber && file.fileNumber.match(/^file(\d+)$/);
        const num = match ? parseInt(match[1], 10) : 0;
        return num > max ? num : max;
      }, 0);
      const nextFileNum = maxFileNum + 1;
      const fileNumber = `file${nextFileNum}`;
      const fileName = `rn${requestNumber}${fileNumber}.${fileType}`
      updateAnswer({ target: { value: answer === "" ? fileName : `${answer}, ${fileName}`}}, questionId)
      setUploadedFiles((prevState) => {
        const newState = [...prevState];
        newState.push({fileName: fileName, fileNumber: fileNumber, fileData: e.target.files[0]});
        return  newState;
      });
    }
}

const downloadFileHandler = async (e, fileName, saved) => {
  e.preventDefault();
  const index = uploadedFiles ? uploadedFiles.findIndex((file) => file.fileName === fileName) : -1;
  if (index > -1 && uploadedFiles[index].fileData) {
    //download from local
    const link = document.createElement("a");
    link.download = fileName;
    link.href = URL.createObjectURL(uploadedFiles[index].fileData);
    link.click();
  } else {
    //download from s3
    if (!campaign.id) return;
    const url = await getFileS3(campaign.id, fileName, authState.accessToken.accessToken);
    if (url.length > 0) {
      window.open(url[0]);
    }
  }
};

  const fileUploadClickHandler = (data) => {
    fileInputref.current.value = "";
    fileInputref.current[`que_${data.id}`].click();
  };



  const createUpload = (data) => {
    let indx = findAnswerIndex(data.id, answers);
    let saved = indx >= 0 ? answers[indx].responseId : 0;
    const answer = indx >= 0 ? answers[indx].answer : "";
    const question = questions.find((q) => q.id === data.questionId);
    let isError = (typeof isSubmit === "boolean" && isSubmit && question && question.required) ? showInputTextErorr(answers, data.id) : false;
    return shouldRender(data, answers, review, questions) ? review ? (
      <Grid key={`q${data.questionId}`}>
        <Typography size="sm" component="p" gutterBottom fontWeight="semibold">
          {getTranslation(data, "text")}
        </Typography>
        <Typography size="sm" component="p" gutterBottom>
        {answer && answer !== "" && answer.split(", ").length > 0 ? (
                <OverlayTrigger
                  placement="bottom"
                  trigger="click"
                  overlay={
                    <Popover id="popover-example">
                      <Popover.Content>
                        {answer.split(", ").map((item) => (
                          <>
                            <Link href="#" key={item} onClick={(e) => downloadFileHandler(e, item, saved)} >{item}</Link>
                            <br/>
                          </>
                        ))}
                      </Popover.Content>
                    </Popover>
                  }
                >
                <Link href="#" onClick={e => e.preventDefault()}>{"View Added Files"}</Link>
              </OverlayTrigger>
                            ) : (
                              "No files attached"
                            )}
                          </Typography>
                        </Grid>
                      ) : (
                        <>
                        <FormLabel>{getTranslation(data, "text")}</FormLabel>
                        <Grid container>
                          <Grid item xs={2}>
                            <input
                              type="file"
                              style={{ display: "none" }}
                              ref={(ref) => (fileInputref.current[`que_${data.id}`] = ref)}
                              onChange={(e) => updateAnswerFile(e, data.id)}
                              name={getTranslation(section, "description") + "-" + data.id}
                            />
                            <Button variant="secondary" startIcon={<FileUploadIcon />} size="small" onClick={() => fileUploadClickHandler(data)}>
                              Upload Files
                            </Button>
                          </Grid>
                          <Grid item xs={10}>
                            <Typography size="xs" fontWeight={"semibold"} component="label">
                            {answer && answer !== "" && answer.split(", ").length > 0 ? (
                              <OverlayTrigger
                                placement="bottom"
                                trigger="click"
                                overlay={
                                  <Popover id="popover-example">
                                                              <Popover.Content>
                            {answer.split(", ").map((item) => (
                              <>
                                <Link href="#" key={item} onClick={(e) => downloadFileHandler(e, item, saved)} >
                                  {item}
                                </Link>
                                <br/>
                              </>
                            ))}
                          </Popover.Content>
                        </Popover>
                      }
                    >
                      <Link href="#" onClick={e => e.preventDefault()}>{"View Added Files"}</Link>
                    </OverlayTrigger>
                  ) : (
                    ""
                  )}
                </Typography>
              </Grid>
            </Grid>
            {isError ? <FormHelperText sx={{ color: "#c21020" }}> {t("bs_required")}</FormHelperText> : null}
          </>
      ) : null;
    }

  const createSelect = (question) => {
    let indx = findAnswerIndex(question.id, answers);
    let answer = indx >= 0 ? answers[indx].answer : "";
    let selectionIdx = answer !== "" && answer ? findSelectionIndex(answer, question.selections): -1;
    let selection = selectionIdx >= 0 ? question.selections[selectionIdx] : null;
    let required = review ? false : requiredValidator(question, section, answers, questionsToValidate);
    let isError = typeof isSubmit === "boolean" && isSubmit ? showInputTextErorr(answers, question.id) : false;
    let questionSelections = question.selections;
    return (
      shouldRender(question, answers, review, questions) && (
        <FormControl fullWidth>
          {review ? (
            <Box key={`b-${question.id}`}>
              <Typography
                size="sm"
                component="p"
                gutterBottom
                key={`q${question.questionId}`}
                paddingLeft={question.idQuestionDepends ? "1.5rem" : ""}
                fontWeight="semibold"
              >
                {getTranslation(question, "text")}
              </Typography>
              <Typography
                size="sm"
                component="p"
                gutterBottom
                key={`a${question.questionId}`}
                paddingLeft={question.idQuestionDepends ? "1.5rem" : ""}
              >
                {selection !== null ? getTranslation(selection, "text") : ""}
              </Typography>
            </Box>
          ) : (
            <>
              <SelectField 
                label={getTranslation(question, "text")}
                required={required !== undefined && required !== null ? required : question.required}
                name={`${getTranslation(section, 'description')}-${question.id}`}
                onChange={(e) => updateAnswer(e, question.id, questionSelections)}
                value={answer}
                error={isError}
                sx={{ "& .MuiFormLabel-root": { fontSize: "12px" } }}
              >
                <Option disabled hidden value="">Select</Option>
                {question.selections
                  .sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1)
                  .map((i) =>
                    i.active ? <Option value={i.value} key={i.id} id={i.id}>{getTranslation(i, 'text')}</Option> : ''
                )}
              </SelectField>
              {isError && <FormHelperText>{t("bs_required")} </FormHelperText>}
            </>
          )}
        </FormControl>
      )
    );
  };

  const getCollumnsByQuestion = (questions, questionsGroup) => {
    const questionsInGroup = questions.filter((q) => q.questionsGroup === questionsGroup);
    return questionsInGroup ? DEFAULT_GRID_COLLUMNS / questionsInGroup.length : DEFAULT_GRID_COLLUMNS;
  };

  return questions
    .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
    .map((q) => {
      const collumnsByQuestion = q.questionsGroup ? getCollumnsByQuestion(questions, q.questionsGroup) : DEFAULT_GRID_COLLUMNS;
      return (
        <Grid key={`gq-${q.id}`} item md={collumnsByQuestion}>
          <div style={{ padding: 10, paddingLeft: q.idQuestionDepends ? "1.5rem" : 10, paddingTop: 6, paddingBottom: 7 }}>
            {q.type === "CHECK" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createCheckSection(q) : <></>}
            {q.type === "OPEN_SMALL" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createInput(q) : <></>}
            {q.type === "DATEPICKER" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createDatePicker(q) : <></>}
            {q.type === "RADIO" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createRadioSection(q) : <></>}
            {q.type ==="FILE" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createUpload(q) : <></>}
            {q.type ==="SELECT" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createSelect(q) : <></>}
          </div>
        </Grid>
      );
    });
};

export default QuestionsComponent;
